import React from "react";

const TwitterBrand1 = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3329_131732)">
      <path
        d="M17.0706 15.4536L24.2718 25.7539H21.3164L15.4401 17.3488V17.3483L14.5774 16.1145L7.71289 6.29541H10.6683L16.2079 14.2198L17.0706 15.4536Z"
        fill="black"
      />
      <path
        d="M28.5423 0H3.45767C1.5481 0 0 1.5481 0 3.45767V28.5423C0 30.4519 1.5481 32 3.45767 32H28.5423C30.4519 32 32 30.4519 32 28.5423V3.45767C32 1.5481 30.4519 0 28.5423 0ZM20.4106 27.1366L14.4642 18.4823L7.01914 27.1366H5.09496L13.6098 17.2393L5.09496 4.84694H11.5894L17.2203 13.042L24.2702 4.84694H26.1944L18.0749 14.2852H18.0744L26.905 27.1366H20.4106Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_3329_131732">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default TwitterBrand1;
